export default __webpack_public_path__ + "static/media/arrowDownRed.46da0b74.svg";